import { normaliseWorkflowStatus } from "./workflow-status-options.ts";

export type WorkflowRunTab = "timeline" | "diagnostics" | "artefacts" | "logs";

function canonicalStatuses(values: readonly string[]): string[] {
  return [...new Set(values.filter(Boolean).map(normaliseWorkflowStatus))];
}

/** Repeated parameters keep multi-select filters intact on refresh and navigation. */
export function readWorkflowStepStatuses(params: URLSearchParams): string[] {
  return canonicalStatuses(params.getAll("stepStatus"));
}

/** Change only the step filter, retaining node selection and unrelated parameters. */
export function withWorkflowStepStatuses(params: URLSearchParams, values: readonly string[]): URLSearchParams {
  const next = new URLSearchParams(params);
  next.delete("stepStatus");
  for (const status of canonicalStatuses(values)) next.append("stepStatus", status);
  return next;
}

export function workflowRunTabHref(runId: string, tab: WorkflowRunTab, params: URLSearchParams): string {
  const query = withWorkflowStepStatuses(params, readWorkflowStepStatuses(params)).toString();
  const pathname = `/workflows/runs/${encodeURIComponent(runId)}${tab === "timeline" ? "" : `/${tab}`}`;
  return `${pathname}${query ? `?${query}` : ""}`;
}
